import { FC } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { SERVICE_PROVIDERS } from 'modules/graphql';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { CREATE_SCHEMAS } from './schemas';
import { createDefaultValues } from './utils';
import { SendingPlatform, ConfigurableSendingPlatforms } from '../../constants';

type AccountFormProviderProps = {
  sendingPlatform: SendingPlatform;
  espDefinitions: SERVICE_PROVIDERS[];
};

export const CreateAccountFormProvider: FC<React.PropsWithChildren<AccountFormProviderProps>> = ({
  children,
  sendingPlatform,
  espDefinitions = [],
}) => {
  /** Type coercions to be updated as providers are added */
  const schema = CREATE_SCHEMAS[sendingPlatform as ConfigurableSendingPlatforms];
  const defaultValues = createDefaultValues(sendingPlatform, espDefinitions);

  type FormSchemaType = Required<z.infer<typeof schema>>;

  const methods = useForm<FormSchemaType>({
    defaultValues,
    mode: 'onChange',
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
